import globalStyle from '@/styles/Global.scss';
import style from './Uketori.scss'
import React, {useEffect, useState} from "react";
import Layout from "@/layout/Layout";
import {useHistory, useParams} from "react-router";
import ImageCard from "@/components/ImageCard";
import {getUketoriCard, resignExchange} from "@/api/exchange";
import AttributeViewer from "@/components/AttributeViewer";
import MButton from "@/components/atom/MButton";

const UketoriCard = () => {
  const history = useHistory()
  // exchangeId
  const {id} = useParams()
  const [cardExchange, setCardExchange] = useState(null)

  useEffect(() => {
    (async () => {
      const cardExchange = await getUketoriCard({id})
      setCardExchange(cardExchange)
    })()
  }, [id])

  const toBack = () => {
    history.push(`/uketori`)
  }

  const toMemo = () => {
    history.push(`/uketori/${id}/memo`)
  }

  const toHomePage = () => {
    history.push(`/uketori/${id}/homePage`)
  }

  const toSchedule = () => {
    history.push(`/uketori/${id}/schedule`)
  }

  const resign = async () => {
    if (!window.confirm('受取名刺を削除します。よろしいですか？')) {
      return;
    }
    await resignExchange({id})
    history.push(`/uketori`)
  }

  return (
    <>
      {
        cardExchange &&
      <Layout category={'UK'}>
        <div className={globalStyle.container}>
          {
            cardExchange.card &&
            <ImageCard id={cardExchange.card.id}></ImageCard>
          }
          <div className={style.dataContainer}>
            <AttributeViewer attributes={cardExchange.card.attributes}></AttributeViewer>
            <div className={globalStyle.footerContainer}>
              <div className={globalStyle.footer}>
                <div className={globalStyle.centerPanel}>
                  <MButton image={'HP.png'} value={'HP'} onClick={toHomePage}></MButton>
                  <MButton image={'schedule.png'} value={'スケジュール'} onClick={toSchedule}></MButton>
                  <MButton image={'memo.png'} value={'メモ'} onClick={toMemo}></MButton>
                  <MButton image={'back.png'} value={'戻る'} onClick={toBack}></MButton>
                  <MButton image={'sakujo.png'} value={'削除'} onClick={ resign }></MButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
      }
    </>
  )
}

export default UketoriCard
